import { UPDATE_SDU_SUBSCRIPTION } from 'constants/actionTypes/sameDayUnlimited';

const initialState = {
    SDUsubscription: {}
};

const reducer = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_SDU_SUBSCRIPTION: {
            return {
                ...state,
                SDUsubscription: payload
            };
        }
        default: {
            return state;
        }
    }
};

export default {
    reducer,
    initialState
};
